function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFileIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("rect", {
    style: {
      opacity: 0.2
    },
    width: 25,
    height: 16,
    x: 3,
    y: 12,
    rx: 1.25,
    ry: 1.25
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#727272"
    },
    d: "M 3,21.75 C 3,22.442 3.5575,23 4.25,23 H 26.75 C 27.442,23 28,22.442 28,21.75 V 8.25 C 28,7.5575 27.442,7 26.75,7 H 14 V 6.25 C 14,5.5575 13.443,5 12.75,5 H 4.25 C 3.5575,5 3,5.5575 3,6.25"
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      opacity: 0.2
    },
    width: 25,
    height: 16,
    x: 3,
    y: 10,
    rx: 1.25,
    ry: 1.25
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "#e4e4e4"
    },
    width: 21,
    height: 10,
    x: 5,
    y: 9,
    rx: 1.25,
    ry: 1.25
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "#8e8e8e"
    },
    width: 25,
    height: 16,
    x: 3,
    y: 11,
    rx: 1.25,
    ry: 1.25
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.1,
      fill: "#ffffff"
    },
    d: "M 4.25 5 C 3.5575 5 3 5.5575 3 6.25 L 3 7.25 C 3 6.5575 3.5575 6 4.25 6 L 12.75 6 C 13.443 6 14 6.5575 14 7.25 L 14 8 L 26.75 8 C 27.442 8 28 8.5575 28 9.25 L 28 8.25 C 28 7.5575 27.442 7 26.75 7 L 14 7 L 14 6.25 C 14 5.5575 13.443 5 12.75 5 L 4.25 5 z"
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFileIcon);
export default __webpack_public_path__ + "static/media/file-icon.308760d26e791e2af30549be475b1fcc.svg";
export { ForwardRef as ReactComponent };